// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".forms-emptycontent[data-v-347b0bce]{flex-basis:100vw;flex-direction:column}", "",{"version":3,"sources":["webpack://./src/FormsEmptyContent.vue"],"names":[],"mappings":"AACA,qCACC,gBAAA,CACA,qBAAA","sourcesContent":["\n.forms-emptycontent {\n\tflex-basis: 100vw;\n\tflex-direction: column;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
